<template>
  <div :class="['cvc-data-block rounded', { 'solid-bg' : solid }]">
    <label>{{ title }}</label>
    <h5>
      <div :class="['status-dot circle inline-block mr1', { 'failed' : !status }]" v-if="showStatus" type="circle" />
      <slot/>
    </h5>
  </div>
</template>

<script>
export default {
  name: 'DataBlock',
  props: {
    title: { type: String, default: '' },
    solid: { type: Boolean, default: false },
    showStatus: { type: Boolean, default: false },
    status: { type: Boolean, default: false }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
.cvc-data-block{
  label {
      font-size: 12px;
  }
  h5 {
    font-size: 22px;
    margin: 0;
  }
  .status-dot {
    background-color: #5BCD1A;
    height: 10px;
    width: 10px;
    &.failed {
      background-color: red;
    }
  }
  &.solid-bg {
    h5 {
      font-size: 16px;
    }
    background-color: rgba(#4C5880, 0.1);
    padding: 5px 8px;
  }
}
</style>
